import React, { Fragment, useState } from "react";
import FieldErrorComponent from "../FieldErrorComponent";
import LabelComponent from "../LabelComponent";
import "./index.css";
const PasswordInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isGeneric = typeof props.isGeneric === "undefined" ? true : props.isGeneric;
  const hasErrors = props.errors && (props.errors.type || props.errors.length > 0);
  const toggleInput = () => {
    setShowPassword(!showPassword);
  };
  const events = {
    onChange: e => {
      if (props.events && props.events.onChange) {
        props.events.onChange(e);
      }
    },
    onFocus: e => {
      if (props.events && props.events.onFocus) {
        props.events.onFocus(e);
      }
    },
    onBlur: e => {
      if (props.events && props.events.onBlur) {
        props.events.onBlur(e);
      }
    }
  };
  if (props.disableShow) {
    return /*#__PURE__*/React.createElement("div", {
      className: `form__field form__field--password ${hasErrors ? "form__field--error" : ""} ${!isGeneric ? "form__field--small" : ""} ${props.labelClassName ? props.labelClassName : ""}`
    }, /*#__PURE__*/React.createElement(LabelComponent, props), /*#__PURE__*/React.createElement("div", {
      className: "form__field-wrapper"
    }, /*#__PURE__*/React.createElement("input", {
      type: "password",
      className: props.className,
      maxLength: props.maxLength,
      placeholder: props.placeholder,
      id: props.id,
      name: props.fieldName,
      value: props.value,
      ref: ref,
      onChange: events.onChange,
      "aria-describedby": `${props.id}-error`
    })), hasErrors && /*#__PURE__*/React.createElement(FieldErrorComponent, props));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `form__field form__field--password ${hasErrors ? "form__field--error" : ""} ${!isGeneric ? "form__field--small" : ""} ${props.labelClassName ? props.labelClassName : ""}`
  }, /*#__PURE__*/React.createElement(LabelComponent, props), /*#__PURE__*/React.createElement("div", {
    className: "form__field-wrapper"
  }, showPassword ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: props.className,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    onFocus: events.onFocus,
    onBlur: events.onBlur,
    id: props.id,
    name: props.fieldName,
    value: props.value,
    onChange: events.onChange,
    ref: ref,
    "aria-describedby": `${props.id}-error`
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `form__field-toggle general-link general-link--small ${props.className ? props.className + "-toggle" : ""}`,
    onClick: toggleInput
  }, props.hideLabel)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "password",
    className: props.className,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    id: props.id,
    name: props.fieldName,
    value: props.value,
    ref: ref,
    onChange: events.onChange,
    "aria-describedby": `${props.id}-error`
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `form__field-toggle general-link general-link--small ${props.className ? props.className + "-toggle" : ""}`,
    onClick: toggleInput
  }, props.showLabel))), hasErrors && /*#__PURE__*/React.createElement(FieldErrorComponent, props));
});
export default PasswordInput;